import { Component } from '@angular/core';
import { ModalController, NavController, NavParams} from 'ionic-angular';
import {FormBuilder, FormGroup} from "@angular/forms";
import {SuperTabsController} from "../../components/ionic2-super-tabs/src";
import {ReportService} from "../../services/report.service";
import {InfoModalPage} from "../info-modal/info-modal";
import { ApiService } from "../../services/api.service";

@Component({
  selector: 'page-report-workorder',
  templateUrl: 'report-workorder.html',
})
export class ReportWorkorderPage {

  data: any;
  reportForm: FormGroup;
  showFooter = false;
  companyParents = [];

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public formBuilder: FormBuilder,
    public superTabsCtrl: SuperTabsController,
    public reportService: ReportService,
    public apiService: ApiService,
    public modalCtrl: ModalController
  ) {
    this.initForm();
    this.loadCompanyParents();
  }

  initForm(){
    this.data = this.reportService.getData();
    if(!this.data.customers) this.data.customers = {};
    let has_data = true;
    this.reportForm = this.formBuilder.group({
      parent_company_id: [(has_data ? this.data.parent_company_id : '')],
      workorder_nr: [(has_data ? this.data.workorder_nr : '')],
      reference_nr: [(has_data ? this.data.reference_nr : '')]
    });
  }

  ionViewDidEnter() {
    console.log('ReportWorkorderPage: ionViewDidEnter');
    this.initForm();
    // iOS footer display fix
    this.showFooter = false;
    setTimeout(() => {
      this.showFooter = true;
    }, 100);
  }

  ionViewDidLeave(){
    console.log('ReportWorkorderPage: ionViewDidLeave');
    this.save();
  }

  loadCompanyParents() {
    if(!this.data._allow_parent_company_id_change){
      return;
    }
    this.apiService.getCompanyParents().then((data: any) => {
      this.companyParents = data;
    });
  }

  save(){
    this.reportForm.markAsTouched();
    if(this.reportForm.valid){
      this.superTabsCtrl.setColor('reportWorkorderPage', 'tab_ok', 'mainTabs');
      this.data._valid.reportWorkorderPage = 1;
    } else {
      this.superTabsCtrl.setColor('reportWorkorderPage', 'tab_error', 'mainTabs');
      this.data._valid.reportWorkorderPage = -1;
    }
    // Assign to data
    Object.assign(this.data, this.reportForm.value);
    this.reportService.setData(this.data);
  }

  confirm(){
    this.save();
    this.reportService.save().then(() => {
      this.superTabsCtrl.slideTo('reportSelectUnitPage', 'mainTabs');
    });
  }

  openInfo(title, text){
    this.modalCtrl.create(InfoModalPage, {
      title: title,
      text: text
    }).present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/report-workorder/report-workorder.ts